<template>
  <div>
    <v-select
      v-model="selectedValue"
      :options="options"
      label="display_name"
      :reduce="option => option.id"
      :filterable="true"
      :clearable="true"
      :disabled="disabled"
    />
  </div>
</template>

<script setup>
import Utils from '@/libs/Utils'
import { ref, computed, watch, onMounted, defineProps, defineEmits } from 'vue'

const props = defineProps({
  modelValue: [String, Number],
  clearAfterSelected: Boolean,
  staffs: Array,
  disabled: Boolean
})

const emit = defineEmits(['update:modelValue', 'change'])

const internalValue = ref(null)

onMounted(() => {
  if (props.modelValue) {
    internalValue.value = props.modelValue
  }
})

watch(() => props.staffs, (newStaffs) => {
}, { deep: true })

watch(() => props.modelValue, (newVal) => {
  internalValue.value = newVal
})

const options = computed(() => {
  const opts = (props.staffs || []).map(staff => ({
    id: staff.id,
    display_name: Utils.genStaffName(staff),
    login_id: staff.login_id
  }))
  return opts
})

const selectedValue = computed({
  get: () => {
    const selectedStaff = options.value.find(opt => opt.id === internalValue.value)
    return selectedStaff || null
  },
  set: (value) => {
    internalValue.value = value
    if (value) {
      const selectedStaff = props.staffs.find(staff => staff.id === value)
      if (selectedStaff) {
        emit('change', selectedStaff)

        // Update modelValue
        emit('update:modelValue', value)

        if (props.clearAfterSelected) {
          setTimeout(() => {
            internalValue.value = null
          }, 100)
        }
      } else {
        emit('update:modelValue', value)
      }
    } else {
      emit('update:modelValue', value)
    }
  }
})
</script>

<style lang="scss" scoped>
.v-select {
  span.selected-tag {
    pointer-events: none;
  }

  span.selected-tag + input[type=search] {
    width: 0 !important;
  }

  &.open input[type=search] {
    width: auto !important;
  }
}
</style>
